import { isNumber } from 'utils/validators/numbers';

import { stringToNumber } from './stringToNumber';

export const stringToNumberOrZero = (value?: string | number | null): number => {
    return value
        ? !isNumber(value) ? stringToNumber(value) ?? 0 : value as number
        : 0;
};
